import { Box, Typography } from '@material-ui/core'
import parse, { domToReact, attributesToProps } from 'html-react-parser'
import StyledHTMLString from '../StyledHTMLString/StyledHTMLString'

const StyledTypography = ({children, ...props}) => {
    const defaultStyle = {
        whiteSpace: 'pre-line'
    }
    const options = {
        replace: (domNode, index) => {
            if(domNode.type === 'tag'){
                const elemProps = attributesToProps(domNode.attribs); 
                let componentType;
                switch(domNode.name){
                    case 'b':
                        elemProps.fontWeight = "bold";
                        componentType = 'span';
                        break;
                    case 'i':
                        elemProps.fontStyle = "italic";
                        componentType = 'span';
                        break;
                    case 'u':
                        elemProps.style={ textDecoration: "underline" }
                        componentType = 'span';
                        break;
                    case 's':
                        elemProps.style={ textDecoration: "line-through" }
                        componentType = 'span';
                        break;
                    case 'h':
                        elemProps.className = `highlight${elemProps.className ? ` ${elemProps.className}` : ''}`
                        componentType = 'span';
                    case 'span':
                        componentType = 'span';
                        break;
                }
                return <Box component={componentType} {...elemProps}>{domToReact(domNode.children, options)}</Box>
            }
        }
    }
    return (
        typeof children === "string" ? <Typography {...props} style={{...props.style, ...defaultStyle}}>{parse(children, options)}</Typography> : null
    )
}

export default StyledTypography